import React from 'react';
import { ArrowLeft } from 'lucide-react';

const BlueHeader = ({ title, subtitle, showBack = false, onBack, showMode = false, modeText = '', actions = [] }) => {
  return (
    <div className="bg-gradient-to-r from-[#0b1e3f] to-[#13315f] px-6 py-8">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-6">
          {showBack && (
            <>
              <button
                onClick={onBack}
                className="flex items-center gap-2 px-5 py-3 bg-white/10 hover:bg-white/20 text-white rounded-xl transition-all backdrop-blur-sm border border-white/20"
              >
                <ArrowLeft className="h-5 w-5" />
                <span className="font-medium">Retour</span>
              </button>
              <div className="h-10 w-px bg-white/20" />
            </>
          )}
          <div>
            <h1 className="text-2xl font-bold text-white mb-1">{title}</h1>
            {subtitle && <p className="text-sm text-blue-200">{subtitle}</p>}
          </div>
        </div>
        <div className="flex items-center gap-3">
          {showMode && (
            <div className="flex items-center gap-2 px-4 py-2 bg-white/10 rounded-lg border border-white/20">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
              <span className="text-sm text-white font-medium">{modeText}</span>
            </div>
          )}
          {actions && actions.map((action, index) => (
            <button
              key={index}
              onClick={action.onClick}
              className={`flex items-center gap-2 px-5 py-3 rounded-xl transition-all ${
                action.primary
                  ? 'bg-gradient-to-r from-[#2563eb] to-[#3b82f6] text-white hover:shadow-lg hover:shadow-blue-500/25 font-semibold'
                  : 'bg-white/10 hover:bg-white/20 text-white border border-white/20 backdrop-blur-sm font-medium'
              }`}
            >
              {action.icon && <action.icon className="h-4 w-4" />}
              <span>{action.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlueHeader;